import type { Step } from '@vrlearning/lesson-schema';
import type { GuideRender } from './guide.js';

/**
 * A step's `narration`, to show as its panel's text, when the step has no
 * `panel` and nobody speaks the narration: text mode (no voice on this
 * headset, the class's Voorlezen off, or the pupil reading), or a voice that
 * guides but has no voice-over for this step. Where the voice speaks it
 * (`voice-text`, `voice-subtitles` with a voice-over), undefined: there the
 * lectern shows the title and the plate only the sentence being spoken
 * (ADR-035). Whitespace collapsed; undefined for a narration without words.
 *
 * The marsrover lesson (15 Oct 2026) had only narrations, and on the test
 * environment, with no voice, the lectern showed only each step's title.
 */
export function unspokenNarration(
  step: Pick<Step, 'panel' | 'narration' | 'voiceover'>,
  render: GuideRender,
): string | undefined {
  if (step.panel) return undefined;
  if (render !== 'text' && step.voiceover !== undefined) return undefined;
  const words = (step.narration ?? '').split(/\s+/).filter(Boolean).join(' ');
  return words === '' ? undefined : words;
}
